import React from "react";
import FormikSelect from "../Formik/FormikSelect";
import FormikInput from "../Formik/FormikInput";
import TableLoader from "../Loaders/TableLoader";
import { Tooltip as ReactTooltip } from "react-tooltip";

function TableBodyWithInputs({
  tableBodyList,
  handleRowClick = () => {},
  name,
  form,
  isLoadingData,
  setFieldValue,
}) {
  const { values } = form;
  const tableData = values?.[name] || [];
  const handleData = (data, item, index) => {
    if (item.customRender)
      return item.customRender({
        item,
        index,
        data,
        setFieldValue,
        fullName: `${name}.${index}.${item.name}`,
      });
    if (!item.name) return;
    const fieldValue = values?.[name]?.[index]?.[item.name] || "";
    if (item.options)
      return (
        <FormikSelect
          {...item}
          key={`${name}.${index}.${item.name}`}
          name={`${name}.${index}.${item.name}`}
          options={item.options}
          disabled={
            item?.handleDisable
              ? item.handleDisable({
                  item,
                  index,
                  data: values?.[name]?.[index],
                })
              : item?.disableInput || false
          }
        />
      );

    return (
      <>
        <FormikInput
          {...item}
          key={`${name}.${index}.${item.name}`}
          name={`${name}.${index}.${item.name}`}
          type={item.type || "text"}
          disabled={
            item?.handleDisable
              ? item.handleDisable({
                  item,
                  index,
                  data: values?.[name]?.[index],
                })
              : item?.disableInput || false
          }
          data-tooltip-id={`${name}.${index}.${item.name}Tooltip`}
          data-tooltip-content={fieldValue}
        />
        <ReactTooltip
          id={`${name}.${index}.${item.name}Tooltip`}
          type="dark"
          effect="solid"
        />
      </>
    );
  };

  if (isLoadingData || tableData?.length === 0) {
    return (
      <tbody className="position">
        <tr>
          <td
            colSpan={tableBodyList?.length}
            style={{ height: 150, width: 400 }}
          >
            <TableLoader isLoading={true} />
          </td>
        </tr>
      </tbody>
    );
  }
  if (tableData?.length === 0) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={tableBodyList?.length}
            style={{ width: 400 }}
            className="text-capitalize"
          >
            No Data Available
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {tableData.map((data, index) => (
        <tr key={data.id} onClick={() => handleRowClick(data, index)}>
          {tableBodyList.map((item) => (
            <td
              className={`text-capitalize ${item.containerClass}`}
              style={item.containerStyle}
              key={item.title}
            >
              {handleData(data, item, index)}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

export default TableBodyWithInputs;
